// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2V-vS","requiredAsterisk":"Info_requiredAsterisk__2jLOb"};